import React from 'react';
import styles from './styles.module.scss';

import Item from '../Item';
import loadingIcon from '../../../assets/icons/loading.gif';

const Loading = ({ spanish }) => (
  <>
    <div />
    <div className={styles.loading}>
      <div>
        <img src={loadingIcon} alt="loading" />
        <p>{spanish ? 'Cargando' : 'Loading'}</p>
      </div>
    </div>
    <div />
  </>
);

const Catalog = ({
  products,
  productsAPI,
  isSearch,
  searchTerm,
  spanish,
  addToCart,
  hasSearchResults,
  isLoadingSearch,
}) => {
  const productsList = hasSearchResults ? (
    products.map((itemInfo, index) => {
      const SKU = parseInt(itemInfo.SKU, 10);
      const filterProductsAPI = productsAPI.find(
        (product) => product.cve_prod === SKU
      );
      return (
        <Item
          productInfo={itemInfo}
          productInfoApi={filterProductsAPI}
          spanish={spanish}
          key={index}
          addToCart={addToCart}
        />
      );
    })
  ) : (
    <div>
      <p>No hay resultado para esta busqueda</p>
    </div>
  );
  const isReady = products && productsAPI;
  return (
    <div className={styles.container}>
      {isSearch ? (
        <h3>
          {spanish ? 'Resultado de la busqueda:' : 'Search results:'}{' '}
          {searchTerm}
        </h3>
      ) : null}
      <div className={styles.content}>
        {isReady && !isLoadingSearch ? (
          productsList
        ) : (
          <Loading spanish={spanish} />
        )}
      </div>
    </div>
  );
};

export default Catalog;
